import { useRef } from 'react';

import { useIsClamped } from '@crm/shared/lib';

import { DealTableCell } from '../DealTableCell';

export const DealNoteCell = ({ textContent }: { textContent: string | null }) => {
    const textRef = useRef<HTMLParagraphElement>(null);
    const text = textContent ?? '';
    const isClamped = useIsClamped(textRef);
    return (
        <DealTableCell isEmpty={!text} className="flex items-center px-1">
            <span
                ref={textRef}
                title={isClamped ? text : undefined}
                className="truncate text-xs font-normal "
            >
                {text}
            </span>
        </DealTableCell>
    );
};
